














































import Vue from "vue";
import { Component, Inject } from "vue-property-decorator";
import { REMINDER_CREATE, REMINDER_EDIT } from "@/route-names";
import EventBus from "@models/eventBus";
import ReminderFilterModel from "@models/reminders/reminderFilterModel";
import ReminderGetListResponse from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/ReminderService/ReminderGetListResponse";

@Component
export default class PageRemindersComponent extends Vue {
  @Inject("eventBus") eventBus: EventBus;
  filter: ReminderFilterModel = new ReminderFilterModel();
  columnNames = ["#", "Название", "", ""];
  createRouteName = REMINDER_CREATE;
  editRouteName = REMINDER_EDIT;
  getDataFunc = this.$api.ReminderService.getListAsync.bind(
    this.$api.ReminderService
  );
  removeFunc = this.$api.ReminderService.deleteAsync.bind(
    this.$api.ReminderService
  );
  async created() {}
  async startDelete(item: ReminderGetListResponse) {
    this.eventBus.deleteEntity.trigger({ id: item.Id });
  }
}
